export const ACTION_PARAM_NAME = 'action';
export const ACTION_RECORD_OPEN = 'record-open';
export const ACTION_RECORD_NEW = 'record-new';
export const ACTION_CATALOG_OPEN = 'catalog';

export const ACTION_RECORD_PARAM_CATALOG_NAME = 'catalog';

export const ACTION_RECORD_PARAM_RECORD_NAME = 'record';
